import $ from 'jquery';

const mobileMenuInit = () => {
  $('[data-mobile-menu-expands]').each((i, menu) => {
    // Set the max height of the entire menu to just the height of the "title" or first line of the menu
    $(menu).css('max-height', $(menu).find('[data-mobile-menu-title]').outerHeight());
  });
};

export default function() {

  mobileMenuInit();

  $(document).on('click', '[data-mobile-menu-expand-collapse]', (e) => {
    // We don't want this to bubble up, as opening a sub-menu would also trigger closing of the parent menu
    e.stopPropagation();

    const $current_menu = $(e.currentTarget).closest('[data-mobile-menu-expands]');

    // Base max height is just the height of the title
    let max_height = $current_menu.find('[data-mobile-menu-title]').outerHeight();
    
    // If the menu isn't open, add the sibling's height to make the menu animate open
    if ($current_menu.hasClass('MobileMenu__item--open') === false) {
      const sibling_height = $current_menu.find('[data-mobile-menu-list]').eq(0).height();
      max_height += sibling_height;
    }
    
    // Animate the current menu open or closed
    $current_menu.css('max-height', max_height).toggleClass('MobileMenu__item--open');

    // Does this menu have a parent that also needs to grow or shrink?
    const $parent_menu = $current_menu.parent().closest('[data-mobile-menu-expands]');
    if ($parent_menu.length > 0) {
      // Temporarily give the parent a huge max height...this lets the child animate freely.
      $parent_menu.css('max-height', 10000);
      setTimeout(() => {
        // Now the the animation has finished, essentially double click the parent to open/close it, forcing it to resize instantly.
        // With the resize finished, the parent menu can be expanded/collapsed with perfectly smooth transitions again. :)
        $parent_menu.find('[data-mobile-menu-expands]').trigger('click');
        $parent_menu.find('[data-mobile-menu-expands]').trigger('click');
      }, 250);      
    }
  });

  // Don't let final links bubble up and cause parent menu to close
  $(document).on('click', '[data-mobile-menu-link]', (e) => {    
    e.stopPropagation();
  });
}

export {
  mobileMenuInit,
};